export const supplierProductMutations = {
  setSupplierProductFormStatus(state, payload) {
    state.supplierProductFormStatus = payload;
  },
  setSupplierProductIsEdit(state, payload) {
    state.supplierProductIsEdit = payload;
  },
  setSupplierProductSelectedForEdit(state, payload) {
    state.supplierProductSelectedForEdit = payload;
  },
  setProductSearchFilterParams(state, payload) {
    state.ProductSearchFilterParams = payload;
  },
  setIndustrialServiceSearchFilterParams(state, payload) {
    state.IndustrialServiceSearchFilterParams = payload;
  },
  setElectronicDocumentSearchFilterParams(state, payload) {
    state.ElectronicDocumentSearchFilterParams = payload;
  },
  setConsultingServiceSearchFilterParams(state, payload) {
    state.ConsultingServiceSearchFilterParams = payload;
  },
  setProductPageNumber(state, payload) {
    state.ProductPageNumber = payload;
  },
  setProductItemsPerPage(state, payload) {
    state.ProductItemsPerPage = payload;
  },
  setProductSelectedItem(state, payload) {
    state.ProductSelectedItem = payload;
  },
  setProductCurrentList(state, payload) {
    state.ProductCurrentList = payload;
  },
  setIndustrialServicePageNumber(state, payload) {
    state.IndustrialServicePageNumber = payload;
  },
  setIndustrialServiceItemsPerPage(state, payload) {
    state.IndustrialServiceItemsPerPage = payload;
  },
  setIndustrialServiceSelectedItem(state, payload) {
    state.IndustrialServiceSelectedItem = payload;
  },
  setIndustrialServiceCurrentList(state, payload) {
    state.IndustrialServiceCurrentList = payload;
  },
  setElectronicDocumentPageNumber(state, payload) {
    state.ElectronicDocumentPageNumber = payload;
  },
  setElectronicDocumentItemsPerPage(state, payload) {
    state.ElectronicDocumentItemsPerPage = payload;
  },
  setElectronicDocumentSelectedItem(state, payload) {
    state.ElectronicDocumentSelectedItem = payload;
  },
  setElectronicDocumentCurrentList(state, payload) {
    state.ElectronicDocumentCurrentList = payload;
  },
  setConsultingServicePageNumber(state, payload) {
    state.ConsultingServicePageNumber = payload;
  },
  setConsultingServiceItemsPerPage(state, payload) {
    state.ConsultingServiceItemsPerPage = payload;
  },
  setConsultingServiceSelectedItem(state, payload) {
    state.ConsultingServiceSelectedItem = payload;
  },
  setConsultingServiceCurrentList(state, payload) {
    state.ConsultingServiceCurrentList = payload;
  },
};
